module.exports = __webpack_public_path__ + "img/faceberry_flipx.22c131c9.png";